import useMutation from 'hooks/use-mutation';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import { useSetHighestZIndexToNode } from 'components/canvas/hooks/use-set-heighest-z-index-to-node';
import { createSurfaceNoteNodeMutation } from 'graphql/surface-node/mutations/surface-note-node/create-surface-note-node';
import { updateSurfaceNoteNodeMutation } from 'graphql/surface-node/mutations/surface-note-node/update-surface-note-node';
import { isArray, pick } from 'lodash';
import { toast } from 'services/toast';
import { flow, set } from 'lodash/fp';

export default function useSaveSurfaceNoteNode() {
  const saveNodeInCache = useSaveNodeInCache();

  const setHighestZIndexToNode = useSetHighestZIndexToNode();

  const [createSurfaceNode] = useMutation(createSurfaceNoteNodeMutation);

  const [updateSurfaceNode] = useMutation(updateSurfaceNoteNodeMutation);

  return function saveSurfaceNoteNode(params) {
    const isUpdate = params.variables.input?.id;

    parseSnippets(params);

    params = parseSlateData(params);

    if (isUpdate) {
      params.variables.input = pick(params.variables.input, [
        'id',
        'name',
        'text',
        'slateData',
        'snippets',
      ]);

      return updateSurfaceNode(params).then((response) => {
        if (response.isFailure) {
          toast.error(response.getErrorMessage());

          return response;
        }

        saveNodeInCache(response.getField('data'));
        setHighestZIndexToNode(response.getField('data'));

        return response;
      });
    }

    params.variables.input = pick(params.variables.input, [
      'name',
      'text',
      'slateData',
      'surface',
      'position',
      'snippets',
    ]);

    return createSurfaceNode(params).then((response) => {
      if (response.isFailure) {
        toast.error(response.getErrorMessage());

        return response;
      }

      saveNodeInCache(response.getField('data'));
      setHighestZIndexToNode(response.getField('data'));

      return response;
    });
  };
}

function parseSlateData(params) {
  const slateData = params.variables.input.slateData?.data;

  return flow(
    set(
      'variables.input.slateData',
      isArray(slateData) ? JSON.stringify(slateData) : slateData,
    ),
    set('variables.input.text', params.variables.input.slateData?.text),
  )(params);
}

function parseSnippets(params) {
  if (params.variables?.input?.snippets) {
    params.variables.input.snippets = params.variables?.input?.snippets?.map(
      (snippet) =>
        pick(snippet, ['id', 'annotationId', 'name', 'text', 'operation']),
    );
  }
}
